import { CircularProgress, IconButton, Tooltip } from "@material-ui/core";

interface props {
  toolTipText: string;
  onClick?: () => void;
  size?: "small" | "medium";
  icon?: any;
  disabled?: boolean;
  isLoading?: boolean;
}

export const CustomIconButton = ({
  toolTipText,
  onClick,
  size,
  icon,
  disabled,
  isLoading,
}: props) => {
  if (disabled === true) {
    return (
      <IconButton
        size={size}
        disabled={true}
        style={{
          opacity: 0.2,
        }}
      >
        {isLoading ? <CircularProgress size={22} color="primary" /> : icon}
      </IconButton>
    );
  }

  return (
    <Tooltip title={toolTipText}>
      <IconButton
        onClick={onClick}
        size={size}
        disabled={disabled}
        style={{
          opacity: disabled ? 0.2 : 1,
        }}
      >
        {isLoading ? <CircularProgress size={22} color="primary" /> : icon}
      </IconButton>
    </Tooltip>
  );
};
